function openCalls() {
    const closedCalls = document.querySelector('[data-name="closed-calls"]')
    const closedCallsButton = document.querySelector(
        '[data-name="closed-calls-button"]'
    )
    const closedCallsButtonLine = document.querySelector(
        '[data-name="closed-calls-button-line"]'
    )

    if (!closedCalls) return

    closedCallsButton.addEventListener('click', () => {
        closedCalls.classList.toggle('opacity-0')
        closedCalls.classList.toggle('invisible')
        closedCalls.classList.toggle('h-0')
        closedCalls.classList.toggle('h-auto')
        closedCallsButtonLine.style.transform =
            closedCallsButtonLine.style.transform === 'rotate(90deg)'
                ? ''
                : 'rotate(90deg)'
    })
}

export default openCalls
